module.exports = __webpack_public_path__ + "img/search-color.6abefd45.gif";